import { axiosAssetDashApi} from './api';

export interface CoinCenter {
  total_coins?: number | null;
  liquid_coins?: number | null;
  locked_coins?: number | null;
  bid_coins?: number | null;
  spent_coins?: number | null;
}

export interface CoinCenterResponse {
  coin_center: CoinCenter;
}

export const getUserCoinCenter = async (): Promise<{
  data: CoinCenterResponse;
}> => {
  return await axiosAssetDashApi.get('/api/api_v4/users/coin-center');
};
